// React
import { memo } from "react";

// Custom Components
import VehicleGroupVehiclesCard from "../VehicleGroupVehiclesCard/VehicleGroupVehiclesCard";
import VehicleGroupInfoCard from "../VehicleGroupInfoCard/VehicleGroupInfoCard";

// Types
import { VehicleGroupDetailProps } from "./types";


const VehicleGroupDetailCard: React.FC<VehicleGroupDetailProps> = (props) => {
  const { vehicleGroupId } = props;

  return (
    <>
      <div className="flex gap-4">
        <div className="h-full ">
          <div className=" min-w-[400px]">
            <VehicleGroupInfoCard vehicleGroupId={vehicleGroupId} />
          </div>
        </div>
        <div className="h-full flex flex-1 flex-col gap-4">
          <div className="">
            <VehicleGroupVehiclesCard vehicleGroupId={vehicleGroupId} />
          </div>
        </div>
      </div>
    </>
  );
};
export default memo(VehicleGroupDetailCard);
